export default Source;

Source.prototype.evaluateObjectFromHeader = evaluateObjectFromHeader;
Source.prototype.compileHeader = noop;

var __request = null;

function Source(opts) {
    opts = opts || {};

    Object.assign(this, opts);

    this.state = 'loading';
    this.busy = null;
    this.fresh = false;
    this.exporting = false;
    this.headers = [];
    this.selected = [];
    this.everythingSelected = false;
    this.pagination = {};
    this.headersStatus = '';
    this.lastFetchResponse = {
        count: null,
        results: []
    };
}

function evaluateObjectFromHeader(header, record) {
    return record;
}
